import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GAP_DEFAULT_SIZE } from '../../../../models/email-template/gap.interface';

/**
 * Region 5 of the mockup: the "+" gap control for inserting a new block at a
 * position. Just the trigger button - the actual block-catalog modal is a
 * single shared instance owned by preview-v2 (see add-block-modal-v2), always
 * anchored at the same spot regardless of which "+" opened it.
 *
 * Also carries the mockup's own "View gap" dropdown (its .between-add holds
 * both controls together) - only shown when there's a real next block to
 * configure a gap towards (nextBlock is null after the last block, and this
 * component isn't rendered at all before the first one - see preview-v2).
 */
@Component({
  selector: 'app-add-block-v2',
  imports: [CommonModule, FormsModule],
  templateUrl: './add-block-v2.component.html',
  styleUrl: './add-block-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddBlockV2Component {
  @Input() addBlockDisabled = false;
  @Input() blockData: any;
  @Input() nextBlock: any = null;
  @Input() gapSize: string = GAP_DEFAULT_SIZE;

  @Output() openAddBlock = new EventEmitter<any>();
  @Output() gapSizeChange = new EventEmitter<string>();

  protected onTriggerClick(): void {
    if (this.addBlockDisabled) {
      return;
    }
    this.openAddBlock.emit(this.blockData);
  }

  protected onGapSizeChange(size: string): void {
    this.gapSizeChange.emit(size);
  }
}
